const DODGER_BLUE_COLOR_NAME = "dodger-blue";
const SPACE_BLUE_COLOR_NAME = "space-blue";
const WHITE_COLOR_NAME = "white";
const IRIS_COLOR_NAME = "iris";
const BLUE_COLOR_NAME = "blue";
const RIVERSTONE_COLOR_NAME = "riverstone";
const PROJECTS_BLUE_COLOR_NAME = "projects-blue";
const CRM_GREEN_COLOR_NAME = "crm-green";
const MARKETING_RED_COLOR_NAME = "marketing-red";
const DEV_ORANGE_COLOR_NAME = "dev-orange";
const WORK_OS_IRIS_COLOR_NAME = "workos-iris";
const BACKGROUND_GRAY_COLOR_NAME = "background-gray";
const BLACK_COLOR_NAME = "black";

export {
  DODGER_BLUE_COLOR_NAME,
  SPACE_BLUE_COLOR_NAME,
  WHITE_COLOR_NAME,
  IRIS_COLOR_NAME,
  BLUE_COLOR_NAME,
  RIVERSTONE_COLOR_NAME,
  PROJECTS_BLUE_COLOR_NAME,
  MARKETING_RED_COLOR_NAME,
  CRM_GREEN_COLOR_NAME,
  DEV_ORANGE_COLOR_NAME,
  WORK_OS_IRIS_COLOR_NAME,
  BACKGROUND_GRAY_COLOR_NAME,
  BLACK_COLOR_NAME
};
